app.controller("termsCtrl", [
  "$scope",
  "ngMeta",
  "$sce",
  "config",
  function ($scope, ngMeta, $sce, config) {
    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    var terms = $sce.trustAsHtml(siteConfig.terms);
    $scope.terms = terms;
    ngMeta.setTitle("Terms and Conditions");

    $scope.$on("$routeChangeSuccess", function () {
      window.scrollTo(0, 0);
    });

    $(".navbar").removeClass("nav-up").addClass("nav-down");
  },
]);

app.controller("faqCtrl", [
  "$scope",
  "$location",
  "ngMeta",
  "$localStorage",
  "getSiteDetails",
  "config",
  function ($scope, $location, ngMeta, $localStorage, getSiteDetails, config) {
    if (config.fullSite === undefined) {
      $localStorage.redirect = window.location.href;
      $location.path("/");
      return {};
    }

    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    ngMeta.setTitle("FAQs");

    getSiteDetails
      .getFaqPageElements(siteConfig.micrositeID)
      .then((result) => {
        $scope.faqPageElements = result.content.map((element) => {
          if (element.type == "FaqSection") {
            element.type = "FaqRows";
            element.payload.faqs = JSON.parse(siteConfig.faqs);
          }
          return element;
        });
      })
      .catch((err) => {
        $scope.faqPageElements = [];
      });

    $scope.$on("$routeChangeSuccess", function () {
      window.scrollTo(0, 0);
    });

    // I wonder if this is used as a custom function in someones faqs
    $scope.register = function () {
      $location.path("/register");
    };

    $scope.alternateIcons = function (i) {
      $("#plus-" + i).toggle();
      $("#minus-" + i).toggle();
    };
  },
]);

app.controller("faqAlternativeCtrl", [
  "$scope",
  "config",
  function ($scope, config) {
    let siteConfig = config.fullSite;

    var questions = JSON.parse(siteConfig.faqs);

    $scope.faqs = questions.splice(0, 6);
  },
]);

app.controller("contactusCtrl", [
  "$scope",
  "ngMeta",
  "getSiteDetails",
  "config",
  function ($scope, ngMeta, getSiteDetails, config) {
    ngMeta.setTitle("Contact Us");

    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    getSiteDetails
      .getContactusPageElements(siteConfig.micrositeID)
      .then((result) => {
        $scope.contactusPageElements = result.content;
      })
      .catch((err) => {
        $scope.contactusPageElements = [];
      });
  },
]);
